import RoleEnum from '@/assets/js/consts/roles.const';

const DEFAULT_USER_ROLE = RoleEnum.supplier;
const APP_OPTION_PER_PAGE = 20;
const APP_OPTION_PHONE_SIZE = 1024;

export { DEFAULT_USER_ROLE, APP_OPTION_PER_PAGE, APP_OPTION_PHONE_SIZE };
